define([
    'common/util/material-colors',
    'backbone.marionette'
], function(
    Colors,
    Mn
    ) {
    const ColorView = Mn.View.extend({
        template: _.template('<li class="color-palette-color-item" style="background-color: <%= color %>;"></li>'),
        events: {
            'click': 'click'
        },

        click: function() {
            this.triggerMethod('select:color', this, this.model.get('color'));
            this.select();
        },

        select: function() {
            this.$('li').addClass('is-selected');
        },

        deselect: function() {
            this.$('li').removeClass('is-selected');
        }
    });

    const ColorLineView = Mn.CompositeView.extend({
        childView: ColorView,
        childViewContainer: 'ul',
        template: _.template('<ul style="float: left; list-style-type: none; padding-left: 0px"></ul>'),

        initialize: function(){
            this.collection = this.model.get('values');
        },

        select: function(color) {
            this.children.each(function(view) {
                if(view.model.get('color') == color) {
                    view.click();
                }
            });
        },

        onChildviewSelectColor: function(childView, color) {
            this.triggerMethod('select:color', childView, color);
        }
    });

    const ColorPaletteView = Mn.CollectionView.extend({
        className: 'color-palette',
        tagName: 'div',
        childView: ColorLineView,
        initialize: function() {
            this._selected = null;
            this.collection = Colors;
        },

        select: function(color) {
            if(!color) {
                color = this.collection.pickRandom();
            }
            this.children.each(function(view) {
                view.select(color);
            });
        },

        onChildviewSelectColor: function(selectedView, color) {
            this.trigger('selected', color);

            if(this._selected) {
                this._selected.deselect();
            }
            this._selected = selectedView;
        }
    });

    return ColorPaletteView;
});



// WEBPACK FOOTER //
// ./common/ui/view/material-color-palette.js